import { styled } from '@nexelem/deprecated-theme';

export const EditorScroller = styled('div')(({ theme }) => {
  return {
    minHeight: '150px',
    border: 0,
    display: 'flex',
    position: 'relative',
    outline: '0',
    zIndex: '0',
    overflow: 'auto',
    resize: 'vertical',
  };
});
